// ------------------------------
// Klaviyo "Added to Cart" Tracking Script
// Fires a Klaviyo event when someone submits an Add to Cart form
// ------------------------------

document.addEventListener("DOMContentLoaded", function () {
  var _learnq = window._learnq || [];

  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var productTitleEl = document.querySelector('[data-product-title], .product__title, h1.product-title');
      var productTitle = productTitleEl ? productTitleEl.textContent.trim() : "Unknown Product";

      _learnq.push(['track', 'Added to Cart', {
        ProductName: productTitle
      }]);

      console.log("✅ Klaviyo 'Added to Cart' tracked via form submit:", productTitle);
    });
  });
});


